import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AppTheme = 'alpine' | 'alpine-dark' | 'quartz' | 'quartz-dark';

interface ThemeState {
  theme: AppTheme;
}

// Load theme from localStorage on initialization
const getInitialTheme = (): AppTheme => {
  if (typeof window !== 'undefined') {
    const savedTheme = localStorage.getItem('app-theme') as AppTheme;
    if (savedTheme && ['alpine', 'alpine-dark', 'quartz', 'quartz-dark'].includes(savedTheme)) {
      return savedTheme;
    }
  }
  return 'alpine';
};

const initialState: ThemeState = {
  theme: getInitialTheme(),
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<AppTheme>) => {
      state.theme = action.payload;
      // Save to localStorage
      if (typeof window !== 'undefined') {
        localStorage.setItem('app-theme', action.payload);
      }
    },
  },
});

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;

